function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C11.1575 18 13.1378 17.2408 14.6881 15.975H17.6986L16.5239 13.9405C17.4571 12.5223 18 10.8246 18 9C18 4.02944 13.9706 0 9 0Z",
    fill: "#09B657",
    style: {
      fill: "#09B657",
      fill: "color(display-p3 0.0356 0.7125 0.3412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.104 11.144C7.624 8.472 11.384 7.768 11.384 5.944C11.384 4.84 10.6 4.04 8.968 4.04C7.864 4.04 6.856 4.52 5.928 5.48L5.08 4.696C6.136 3.576 7.384 2.824 9.112 2.824C11.368 2.824 12.824 3.992 12.824 5.832C12.824 8.248 9 8.744 9.416 11.144H8.104ZM8.792 15.08C8.216 15.08 7.768 14.68 7.768 14.04C7.768 13.4 8.232 12.968 8.792 12.968C9.352 12.968 9.816 13.4 9.816 14.04C9.816 14.68 9.352 15.08 8.792 15.08Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardQuestionMark);
export default __webpack_public_path__ + "static/media/cardQuestionMark.884aa146c89592092b21ebc44dc700ad.svg";
export { ForwardRef as ReactComponent };